import { render } from "./HeaderBlockSmall.vue?vue&type=template&id=0cd00db0"
import script from "./HeaderBlockSmall.vue?vue&type=script&lang=js"
export * from "./HeaderBlockSmall.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__